import React, { useEffect } from 'react';
import ConsentGuard from './ConsentGuard';

const MetarWidgetContent: React.FC = () => {
  useEffect(() => {
    // Load the METAR widget script
    const script = document.createElement('script');
    script.src = 'https://metar-taf.com/embed-js/EDEB?qnh=hPa&rh=rh&target=aal5NdeK';
    script.async = true;
    script.defer = true;
    script.crossOrigin = 'anonymous';
    
    document.body.appendChild(script);

    // Cleanup function to remove the script when component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="mt-4 mb-10 mx-auto" style={{ maxWidth: '300px' }}>
      <a 
        href="https://metar-taf.com/metar/EDEB" 
        id="metartaf-aal5NdeK" 
        style={{
          fontSize: '18px',
          fontWeight: 500,
          color: '#000',
          width: '300px',
          height: '435px',
          display: 'block'
        }}
      >
        METAR Bad Langensalza Airfield
      </a>
    </div>
  );
};

const MetarWidget: React.FC = () => {
  return (
    <ConsentGuard title="METAR Wetter-Daten">
      <MetarWidgetContent />
    </ConsentGuard>
  );
};

export default MetarWidget;
